export default __webpack_public_path__ + "static/media/multiple-calendar-accounts@2x.a9695f8a.jpg";